import { Flex, Tabs, Typography } from "antd";
import { useSearchParams } from "react-router-dom";

import Breadcrumbs from "@/components/ui/Breadcrumbs";

import TriggersTab from "./TriggersTab";
import VariablesTab from "./VariablesTab";
import TemplatesTab from "./TemplatesTab";

const { Title } = Typography;

const DEFAULT_TAB = "triggers";

const NoticeSettings = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get("tab") || DEFAULT_TAB;

  const handleTabChange = (key) => {
    const next = new URLSearchParams(searchParams);
    next.set("tab", key);
    setSearchParams(next, { replace: true });
  };

  return (
    <Flex vertical gap={25} className="h-100">
      <Flex vertical gap={10}>
        <Breadcrumbs
          items={[
            {
              title: "Административная панель",
            },
            {
              title: "Настройки уведомлений",
            },
          ]}
        />
        <Title level={2} className="no-margin">
          Настройки уведомлений
        </Title>
      </Flex>
      <Tabs
        activeKey={activeTab}
        items={[
          {
            key: "triggers",
            label: "Триггеры",
            children: <TriggersTab />,
          },
          {
            key: "variables",
            label: "Переменные",
            children: <VariablesTab />,
          },
          {
            key: "templates",
            label: "Шаблоны",
            children: <TemplatesTab />,
          },
        ]}
        onChange={handleTabChange}
        style={{ flex: 1, minHeight: 0 }}
        className="tabs--h-100"
      />
    </Flex>
  );
};

export default NoticeSettings;
